/* eslint-disable react/no-danger */
import { Link } from 'gatsby';
import _ from 'lodash';
import { motion } from 'framer-motion';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneInnerPageProcessMethod({ data, id }) {
  const { title, text, activeLevel, items, backgroundImage, mobileBackgroundImage } = data;
  return (
    <section id={id} className="relative overflow-hidden bg-[#333]">
      <div
        className="max-w-[1238px] mx-auto relative px-6 2xl:px-0 py-[50px] lg:py-[100px] z-10
      flex flex-col gap-y-[30px] lg:gap-y-[52px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5 lg:gap-y-[30px] max-w-[1024px] mx-auto">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-white
              h2-child:leading-1.2 text-center h2-child:m-0"
            />
            <div className="h-[2px] w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#ccc] p-child:text-clamp12to18 p-child:font-normal
              p-child:leading-[1.4] p-child:mb-0 
              p-child:ltr:font-URWDINRegular 
              p-child:rtl:font-GESSTwoDWTCLight
              text-center"
          />
        </motion.div>

        {_.isEmpty(items) || (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            className="hidden lg:flex flex-row gap-x-9 justify-center">
            {_.map(items, (item, index) => (
              <Link
                href={item?.content?.link?.url}
                key={index}
                className={`flex flex-col gap-[35px] max-w-[146px] items-center
                process-line:last:before:!hidden relative process-count
                z-${index + 1}
                ${ item?.content?.link?.url === '#' ? 'pointer-events-none' : 'pointer-events-auto'}
                `}>
                <div
                  className={`flex justify-center items-center
                  relative before:content-[''] before:inline before:absolute
                  before:h-[2px] before:w-[calc(100%+24px)] before:rtl:right-full
                  before:ltr:left-full
                  after:content-[''] after:inline after:absolute
                  after:border-2 after:transition-all after:duration-300
                  process-way ${
                    item?.content?.link?.url === '#'
                      ? `before:bg-[#EBEBEB] border-[#EBEBEB] after:rounded-full after:bg-[#343434] 
                      w-[88px] h-[88px] after:h-full after:w-full hover:after:bg-[#EBEBEB] 
                      [&:hover>span]:text-[#333] pointer-events-none`
                      : `${
                          activeLevel - 1 === index
                            ? 'after:bg-[#CE435B]'
                            : 'after:bg-[#343434] hover:after:bg-[#CE435B]'
                        } 
                        hover:after:rotate-45 hover:after:border-[#CE435B]
                        after:rotate-45 after:border-[#CE435B] before:bg-[#CE435B] 
                        w-20 h-20 after:h-[76px] after:w-[76px]`
                  }`}>
                  <span
                    className="text-white 
                    ltr:font-LibreBaskervilleRegular 
                    rtl:font-GESSTwoDWTCMedium 
                    text-[30px] 
                    font-bold relative z-50">
                    {item.content.number}
                  </span>
                </div>
                <span
                  className="text-white 
                  ltr:font-URWDINRegular 
                  rtl:font-GESSTwoDWTCLight capitalize text-[20px] leading-1.5
                text-center">
                  {item.content.link.name}
                </span>
              </Link>
            ))}
          </motion.div>
        )}

        {_.isEmpty(items) || (
          <div className="flex flex-col gap-y-5 lg:hidden">
            <div className="flex flex-row flex-nowrap items-center">
              {_.map(items, (item, index) => (
                <Link
                  href={item?.content?.link?.url}
                  key={index}
                  className={`w-[32px] h-[32px] flex flex-col gap-[12px] items-center
                process-line:last:before:!hidden flex-1 flex-grow
                ${
                  item?.content?.link?.url === '#'
                    ? 'pointer-events-none md:pointer-events-auto'
                    : ''
                }`}>
                  <div
                    className={`flex justify-center items-center
                    relative before:content-[''] before:inline before:absolute
                    before:h-[32px] before:w-[2px] before:top-full
                    after:content-[''] after:inline after:absolute
                    after:border-2
                    process-way ${
                      item?.content?.link?.url === '#'
                        ? `relative top-[-6px] border-[#EBEBEB] 
                        after:rounded-full after:bg-[#333]
                      w-[32px] h-[32px] after:h-full after:w-full 
                      focus:after:md:bg-[#EBEBEB] pointer-events-none 
                      [&:focus>span]:md:text-[#333]`
                        : `${
                            activeLevel - 1 === index
                              ? `after:bg-[#CE435B] before:bg-[#CE435B] after:rotate-45
                        focus:after:border-[#CE435B]`
                              : 'after:bg-[#333] focus:after:bg-[#CE435B]'
                          } 
                        after:rotate-45 after:border-[#CE435B]
                        w-[20px] h-[20px] after:h-[24px] after:w-[25px]`
                    }`}>
                    <span
                      className="text-white 
                      ltr:font-LibreBaskervilleRegular 
                      rtl:font-GESSTwoDWTCMedium  
                      text-[12px] font-bold
                  relative z-50">
                      {item.content.number}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
            <div className="w-full h-[2px] bg-[#CE435B]" />
            <div className="flex flex-col gap-y-[12px]">
              <span className="text-[#CCC] 
              ltr:font-URWDINRegular 
              rtl:font-GESSTwoDWTCLight 
              capitalize text-[12px] 
              leading-1.5">
                Step {activeLevel}
              </span>
              <span className="text-white text-[16px] 
              ltr:font-URWDINRegular 
              rtl:font-GESSTwoDWTCLight 
              leading-[1.4]">
                {items[activeLevel - 1].content.link.name}
              </span>
            </div>
          </div>
        )}
      </div>
      {_.isEmpty(mobileBackgroundImage) || (
        <div
          className="bg-[#333] md:hidden absolute bottom-0 w-full lazy-load-image:!flex
          lazy-load-image:h-full h-full mImage">
          <LazyLoadImage
            src={mobileBackgroundImage.url}
            width="100%"
            effect="blur"
            wrapperClassName="bg-gradient-wrapper relative 
            after:content-[''] after:block 
            after:absolute after:left-0 after:w-full after:top-0 after:h-full
            after:bg-gradient-to-b after:from-[rgba(51,51,51,0)] after:to-[rgba(51,51,51,1)]"
            className="w-full h-full object-cover bg-blend-multiply !opacity-10"
          />
        </div>
      )}
      {_.isEmpty(backgroundImage) || (
        <div
          className="bg-[#333] hidden md:block absolute bottom-0 w-full
          lazy-load-image:!flex lazy-load-image:h-full h-full dImage">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            wrapperClassName="bg-gradient-wrapper relative 
            after:content-[''] after:block 
            after:absolute after:left-0 after:w-full after:top-0 after:h-full
            after:bg-gradient-to-b after:from-[rgba(51,51,51,0)] after:to-[rgba(51,51,51,1)]"
            className="w-full h-full object-cover bg-blend-multiply !opacity-10"
          />
        </div>
      )}
    </section>
  );
}
